import React from "react";
import sectionImg from "../../assets/images/sec2img.png";
import PrimaryButton from "../common/PrimaryButton";

const Section2 = () => {
  return (
    <div className="relative overflow-visible flex bg-[#1E1E1E] w-full mx-auto max-w-screen-2xl items-center justify-center">
      <div className="py-6 relative sm:pb-20 mx-4 sm:mx-12 flex flex-col md:flex-row gap-5 sm:gap-10 justify-center items-center">
        <div className="flex flex-col gap-4">
          <h1 className="jost-regular text-white text-3xl sm:text-5xl max-w-xl">
            Psyche Ethos: Realising Potential,
            <span className="italic font-eiko-thin"> Overcoming Obstacles</span>
          </h1>
          <p className="max-w-2xl text-white">
            We at Psyche Ethos are aware that every organisation faces
            challenges that may limit its capacity to operate and grow. It can
            be difficult for internal teams to pinpoint the actual origins of
            these problems because they are often deeply rooted in people,
            culture, or practices. If these issues are not resolved, they could
            get worse and result in inefficiencies and inconsistencies that
            makes productivity challenging.
            <br />
            <br />
            Here's where we emerge. Psyche Ethos offers a distinct method for
            recognising, characterising, and resolving issues. We find creative
            answers to even the most enduring problems by fusing keen analytical
            reasoning with intuitive understanding.
          </p>
          {/* <PrimaryButton isBlack className="w-[210px] uppercase mt-4 sm:mt-6 bg-white !text-black" icon> */}
          {/*   Learn more */}
          {/* </PrimaryButton> */}
        </div>

        <div className="relative ">
          <img src={sectionImg} className="sm:-mt-20" alt="" />
        </div>
      </div>
    </div>
  );
};

export default Section2;
